import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "ticketino-api-client";
import { useLanguage } from "../hooks/useLanguage";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";

import iconSmartphone from "../images/icons/smartphone.svg";

const Confirmation = () => {
    const [regularToken, setRegularToken] = useState(null);
    const [resources, setResources] = useState({});

    const { orderId } = useParams();
    const [order, setOrder] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const { language } = useLanguage();

    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    // Remove adminNewBookingUsername from sessionStorage on mount
    useEffect(() => {
        sessionStorage.removeItem("adminNewBookingUsername");
    }, []);

    //useEffect(() => {
    //    // gtm - purchase
    //    window.dataLayer = window.dataLayer || [];
    //    window.dataLayer.push({
    //        'event': 'purchase'
    //    });
    //}, [])

    useEffect(() => {
        setRegularToken(localStorage.getItem("token"));
    }, []);

    useEffect(() => {
        requestResources();
    }, [language]);

    useEffect(() => {
        if (regularToken && orderId && orderId.length > 0) {
            // Set axios headers with token before making the API call
            axios.defaults.headers.common["Authorization"] = "Bearer " + regularToken;
            api.defaults.headers.common["Authorization"] = "Bearer " + regularToken;
            
            loadOrder(orderId);
            localStorage.removeItem("OrderId");
        }
    }, [regularToken, orderId]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId, attempt = 1) => {
        try {
            setIsLoading(true);

            const orderResp = await fetchOrderById(orderId);

            // If invoiceNumber missing and attempts < 7, retry
            if ((!orderResp?.invoiceNumber || orderResp.invoiceNumber === "") && attempt < 7) {
                console.log(`Retrying to fetch order... Attempt ${attempt + 1}`);
                await new Promise((resolve) => setTimeout(resolve, 2000)); // optional delay before retry
                return loadOrder(orderId, attempt + 1);
            }

            if (!orderResp?.invoiceNumber) {
                setError("Invoice number is missing after multiple attempts.");
            } else {
                setError(null);
            }

            setIsLoading(false);
            setOrder(orderResp);
        }
        catch (error) {
            console.error(error);
            setError("Failed to load order.");
            setIsLoading(false);
        }
    }

    const fetchOrderById = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error('Error fetching order by Id:', error);
            throw error;
        }
    }

    return (
        <>
            <Header language={language} pagePath={`confirmation/${orderId}`} pageTitle={resources?.ConfirmationTitle}
                isLoginVisible={false} isSoppingcartVisible={false} isUsernameVisible={false} />

            {isLoading ? (
                <>
                    <div className="loading-wrapper">
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="transparent"
                            top="50%"
                            resources={resources}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="page-container">
                        <div className="container wrapper text-center">

                            {/* Show error message if any */}
                            {error && (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="alert alert-danger" role="alert">
                                            <p dangerouslySetInnerHTML={{ __html: resources?._ErrorOrder?.replaceAll("${orderId}", orderId) }}></p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {!error && order && order.invoiceNumber && order.invoiceNumber !== 0 && (
                                <>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span dangerouslySetInnerHTML={{ __html: resources?.ConfirmationText1 }}></span>
                                        </div>
                                    </div>

                                    {order.paymentMethodId === 2 && (
                                        <div className="row">
                                            <div className="col-md-12">
                                                    <strong><span dangerouslySetInnerHTML={{ __html: resources?.ConfirmationTextInvoice }}></span></strong>
                                            </div>
                                        </div>
                                    )}

                                    <div className="row mt-5 mb-5">
                                        <div className="col-7 col-md-8 mx-auto">
                                            <div className="custom-box-red">
                                                <img 
                                                    src={iconSmartphone} 
                                                    alt="Smartphone" 
                                                    style={{ display: 'block', margin: '0 auto 1rem auto', width: '48px', height: '48px' }} 
                                                />
                                                <p dangerouslySetInnerHTML={{ __html: resources?.ConfirmationText2 }}></p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <p dangerouslySetInnerHTML={{ __html: resources?.ConfirmationText3 }}></p>
                                        </div>
                                    </div>

                                    <div className="row mt-4">
                                        <div className="col-12 text-center">
                                            <button
                                                className="btn-custom white"
                                                type="submit"
                                                onClick={() => window.location.href = "https://www.wow-museum.ch"}
                                            >
                                                {resources?._Back}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    <Footer language={language} />
                </>
            )}
        </>
    )
}

export default Confirmation